<template>
    <div class="row">
        <ContractInfo :loading="loading" :data="contract" />

        <div class="col-6">
            <div class="col-12 mb-3" v-if="editStartDate">
                <label class="form-label" for="start_date">
                    {{ $trans.get('__JSON__.Start Date') }}
                </label>
                <input type="date" name="start_date" class="form-control" :class="{ 'is-invalid': this.hasError('start_date') }" id="start_date" v-model="formData.start_date">
                <span class="invalid-feedback" role="alert" v-if="this.hasError('start_date')">
                    <strong>{{ this.getError('start_date') }}</strong>
                </span>
            </div>
            <div class="col-12">
                <label class="form-label" for="end_date">
                    {{ $trans.get('__JSON__.End Date') }}
                </label>
                <input type="date" name="end_date" class="form-control" :class="{ 'is-invalid': this.hasError('end_date') }" id="end_date" v-model="formData.end_date">
                <span class="invalid-feedback" role="alert" v-if="this.hasError('end_date')">
                    <strong>{{ this.getError('end_date') }}</strong>
                </span>
            </div>
            <div class="col-12 mt-5" v-if="isEmployment">
                <div class="alert alert-warning p-3" role="alert">
                    <div class="d-flex align-items-center">
                        <div class="w-8 text-lg">
                            <i class="bi bi-exclamation-triangle-fill"></i>
                        </div>
                        <span class="font-bold">Let op!</span>
                    </div>
                    <div class="ps-8">
                        <p class="text-sm">
                            Het zetten of wijzigen van een einddatum is <u>geen</u> uitdienst melding.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RequestHandler from "../../mixins/RequestHandler";
    import ContractInfo from "../ContractInfo.vue";

    export default {
        name: 'EditContractForm',
        mixins: [ RequestHandler ],
        components: {ContractInfo},
        data() {
            return {
                contractId: this.$parent.$data.contractId,
                loading: false,
                contract: {},
                editStartDate: false,
                isEmployment: false,
                formData: {
                    start_date: null,
                    end_date: null,
                },
            }
        },
        methods: {
            fetch() {
                if (! this.contractId) return

                this.loading = true

                this.makeRequest('post', '/api/contract/info',
                    {contractId: this.contractId},
                    response => {
                        const contractInfo = response.data.contract

                        this.$parent.$data.data.contractType = contractInfo.type
                        this.contract = response.data
                        this.editStartDate = (!contractInfo.is_started && contractInfo.is_placement)
                        this.isEmployment = contractInfo.is_employment
                        this.formData.end_date = contractInfo.end_date

                        if(this.editStartDate) {
                            this.formData.start_date = contractInfo.start_date
                        }
                    },
                    error => console.log(error),
                    () => this.loading = false
                )
            },
        },
        mounted() {
            this.fetch()
        },
    }
</script>
